<template>
  <div class="swiper_box">
    <el-carousel v-if="!isLoading" trigger="click" arrow="always" :interval="interval" :autoplay="false">
      <el-carousel-item
        v-for="(item, index) in filteredBanners"
        :key="index"
        @click.native="goToLink(item.link)"
        :class="[item.link ? 'clickable' : '']"
      >
        <BannerItemV1 v-if="item.bannerVersion === 'v1'" v-bind="item" />
        <BannerItemV2 v-else-if="item.bannerVersion === 'v2'" v-bind="item" />
        <BannerItemV3 v-else-if="item.bannerVersion === 'v3'" v-bind="item" />
        <BannerItemV4 v-else-if="item.bannerVersion === 'v4'" v-bind="item" />
        <BannerItemV5 v-else-if="item.bannerVersion === 'v5'" v-bind="item" />
        <BannerItemV6 v-else-if="item.bannerVersion === 'v6'" v-bind="item" />
        <BannerItemV7 v-else-if="item.bannerVersion === 'v7'" v-bind="item" />
        <BannerItemV8 v-else-if="item.bannerVersion === 'v8'" v-bind="item" />
        <NorouziGift v-else-if="item.bannerVersion === 'norouziGift'" v-bind="item" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import BannerItemV1 from './item/v1/BannerItem.vue';
import BannerItemV2 from './item/v2/BannerItem.vue';
import BannerItemV3 from './item/v3/BannerItem.vue';
import BannerItemV4 from './item/v4/BannerItem.vue';
import BannerItemV5 from './item/v5/BannerItem.vue';
import BannerItemV6 from './item/v6/BannerItem.vue';
import BannerItemV7 from './item/v7/BannerItem.vue';
import BannerItemV8 from './item/v8/BannerItem.vue';
import NorouziGift from './item/NorouziGift.vue';
import { apiGetFundStatus } from '@/resource';
import moment from 'moment';

export default {
  name: 'Banner',
  components: {
    BannerItemV1,
    BannerItemV2,
    BannerItemV3,
    BannerItemV4,
    BannerItemV5,
    BannerItemV6,
    BannerItemV7,
    BannerItemV8,
    NorouziGift
  },
  data() {
    return {
      interval: 10000,
      isFunded: false,
      isLoading: false
    };
  },
  computed: {
    filteredBanners() {
      const currentCountry = this.countryCode;
      const currentDateTime = moment();
      let banners = this.$config.banner(this.regulator)(this.GLOBAL_DOMAIN_WEBSITE);

      // filter country
      banners = banners.filter(
        ({ excludeCountries, onlyForCountries, title, endDateTime, startDateTime, limitDomain }) => {
          if (excludeCountries) {
            if (excludeCountries[currentCountry]) {
              return false;
            } else if (title === 'banner.affiliateChallengerCup.title') {
              return this.$store.state.common.salesCompany === 'EMEA' && this.$store.state.common.userTypeEnum === 'IB'
                ? true
                : false;
            } else {
              return true;
            }
          }

          if (onlyForCountries) {
            return onlyForCountries[currentCountry];
          }

          if (limitDomain) {
            if (!window.location.origin.includes('vtmarkets-pro.com')) {
              return false;
            }
          }

          /**
           * Default: show banner if no excludeCountries and onlyForCountries
           */
          return true;
        }
      );

      // filter dateTIme
      banners = banners.filter(item => {
        if (item.startDateTime && !currentDateTime.isAfter(moment(item.startDateTime))) return false;
        if (item.endDateTime && !currentDateTime.isBefore(moment(item.endDateTime))) return false;

        return true;
      });

      // filter eligible campaign if any
      banners = banners.filter(item => {
        if (
          item.filterEligibleCampaign &&
          this.eligibleCampaigns.length &&
          !this.eligibleCampaigns.find(c => c.id === item.filterEligibleCampaign)
        ) {
          return false;
        }

        return true;
      });

      return banners;
    },
    countryCode() {
      return this.$store.state.common.countryCode;
    },
    eligibleCampaigns() {
      return this.$store.state.promotion.eligibleCampaigns;
    }
  },
  mounted() {
    this.getFundBalance();
  },
  methods: {
    goToLink(link) {
      link && window.open(link);
    },
    getFundBalance() {
      try {
        this.isLoading = true;
        apiGetFundStatus().then(resp => {
          this.isFunded = resp.data.data.isFunded;
          this.isLoading = false;
        });
      } catch (error) {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/layout/banner.scss';
</style>
<style lang="scss">
@media (max-width: 768px) {
  [dir='rtl'] .el-carousel__arrow--right {
    right: unset !important;
    left: 4px;
  }
  [dir='rtl'] .el-carousel__arrow--left {
    right: 4px;
  }
  .dark_blue_button {
    &:hover,
    &:active {
      background-color: $primary-dark-blue;
      color: $white;
      border-color: transparent;
    }
  }
}
</style>
